import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function StatusSuccess({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 16 16"
    >
      <Path
        d="M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM5.08507 8.08331C4.85399 8.31439 4.85399 8.68904 5.08507 8.92012L6.56688 10.4019C6.82723 10.6623 7.24934 10.6623 7.50969 10.4019L11.3635 6.5481C11.5946 6.31701 11.5953 5.94253 11.365 5.71062C11.1336 5.47755 10.7568 5.47689 10.5246 5.70914L7.03828 9.19541L5.92106 8.08251C5.68986 7.85219 5.31583 7.85255 5.08507 8.08331Z"
        fill={iconColor}
      />
    </Svg>
  );
}
